import { OrderCategory } from "../../../api/endpoints/Order";
import { last } from "lodash";
import React, { ElementType, Fragment } from "react";
import { TOrderProductData } from "../../../api/endpoints/OrderProduct";

const formatEnsembleMembers = (values: Array<number>) => {
  return last(values.filter(v => v === 50 || v === 100));
}

const EnsembleMembers = (props: {
  values: NonNullable<TOrderProductData<OrderCategory.REALTIME>['number']>
  as: ElementType
}) => {
  const { values, as: Component } = props;

  return (
    <Fragment>
      <Component>
        {formatEnsembleMembers(values)}
      </Component>
    </Fragment>
  );
};

export default EnsembleMembers;
